var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$vuetify.goTo(_vm.item.link, {
      offset: _vm.$store.state.section.stickyHeader.height
    })}}},'v-btn',_vm.props,false),[_vm._v(_vm._s(_vm.item.name))])}
var staticRenderFns = []

export { render, staticRenderFns }